import _classCallCheck from "/jenkins/workspace/jenkins-non-prod-pipelines-LOS-UI-Login-UI-qa-11/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/jenkins/workspace/jenkins-non-prod-pipelines-LOS-UI-Login-UI-qa-11/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/jenkins/workspace/jenkins-non-prod-pipelines-LOS-UI-Login-UI-qa-11/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/jenkins/workspace/jenkins-non-prod-pipelines-LOS-UI-Login-UI-qa-11/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/jenkins/workspace/jenkins-non-prod-pipelines-LOS-UI-Login-UI-qa-11/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/inherits";
import React, { Component } from 'react';
import AutoSizer from 'react-virtualized/dist/commonjs/AutoSizer';
import DesktopTable from './DesktopTable';

var mql = function mql(width) {
  return window.matchMedia("(min-width: ".concat(width, "px)"));
};

var DefiTable =
/*#__PURE__*/
function (_Component) {
  _inherits(DefiTable, _Component);

  function DefiTable() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, DefiTable);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(DefiTable)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      mobile: !mql(_this.props.mobileWidth).matches
    };

    _this.mediaQueryChanged = function () {
      _this.setState({
        mobile: !mql(_this.props.mobileWidth).matches
      });
    };

    return _this;
  }

  _createClass(DefiTable, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      mql(this.props.mobileWidth).addListener(this.mediaQueryChanged);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      mql(this.props.mobileWidth).removeListener(this.mediaQueryChanged);
    }
  }, {
    key: "createWrapperStyling",
    value: function createWrapperStyling(fontSize) {
      if (this.props.expandedStatus) {
        return {
          height: '100%',
          maxWidth: '100%',
          overflowX: 'hidden',
          paddingTop: '3px',
          fontSize: fontSize ? fontSize : '10px'
        };
      } else {
        return {
          height: '100%'
        };
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          filterCriteria = _this$props.filterCriteria,
          expandedStatus = _this$props.expandedStatus,
          setFilterCriteria = _this$props.setFilterCriteria,
          config = _this$props.config,
          link = _this$props.link,
          adjustHeight = _this$props.adjustHeight,
          preRowRender = _this$props.preRowRender,
          customRowRenderer = _this$props.customRowRenderer,
          onRowClick = _this$props.onRowClick,
          rowHeight = _this$props.rowHeight,
          fontSize = _this$props.fontSize;

      if (this.state.mobile && !expandedStatus) {
        return React.createElement("div", {
          style: {
            height: '100%'
          },
          "data-testid": "mobile-table"
        }, this.props.mobileTable());
      } else {
        return React.createElement("div", {
          style: this.createWrapperStyling(fontSize)
        }, React.createElement(AutoSizer, null, function (_ref) {
          var height = _ref.height,
              width = _ref.width;
          var adjustedHeight = adjustHeight ? height + adjustHeight : height - 103;
          return React.createElement(DesktopTable, {
            link: link,
            rows: children.get('rows'),
            width: width,
            height: adjustedHeight,
            setFilterCriteria: setFilterCriteria,
            filterCriteria: filterCriteria,
            config: config,
            preRowRender: preRowRender,
            customRowRenderer: customRowRenderer,
            onRowClick: onRowClick,
            rowHeight: rowHeight
          }, children);
        }));
      }
    }
  }]);

  return DefiTable;
}(Component);

export default DefiTable;